import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_AUTO_FREE_PROMOTIONS_ROLLOUT = createFcmDetails('auto_free_promotions_rollout', {
	owner: 'Starfish',
	context: 'Auto Free Promotions',
	description: `
		Roll out auto free promotions on petition creation by country and percentage. 
	`,
	import: false,
	template: {
		traffic_percentage: 20,
		user_safelist: [123, 456],
		user_blocklist: [789],
	},
});
